import { useState } from 'react';
import { Link } from 'react-router-dom';
import { GoHome } from "react-icons/go";        // Início
import { FiShoppingCart } from "react-icons/fi"; // Pedidos
import { FiUser, FiUsers } from "react-icons/fi"; // Outline do usuário, Equipe
import { MdAddShoppingCart, MdCropFree, MdOutlineSpaceDashboard, MdMoreHoriz, MdInventory2, MdTableRestaurant, MdRestaurantMenu, MdSettings, MdPalette } from "react-icons/md"; // Novo Pedido, Mesas, Gestão, Mais, Estoque, Cardápio, Configurações, Personalização
import { FiPackage, FiTruck } from "react-icons/fi"; // Retirada, Entregas
import { VscLayoutMenubar } from "react-icons/vsc"; // Painel de Pedidos
import styles from './FooterOpcoes.module.css';

function FooterOpcoes({ typeView }) {
  // Estabelecimentos do tipo restaurante (sem universidade vinculada) não têm retirada por código
  const isRestaurante = !localStorage.getItem('id_universidade');
  const [maisAberto, setMaisAberto] = useState(false);

  const itensMais = [
    { to: "/equipe/painelpedidos", label: "Painel de Pedidos", icon: <VscLayoutMenubar /> },
    // "Chamar Cozinha" desativado por enquanto — ver App.js
    { to: "/equipe/estoque", label: "Estoque", icon: <MdInventory2 /> },
    ...(isRestaurante ? [] : [{ to: "/equipe/retirada", label: "Retirada", icon: <FiPackage /> }]),
    { to: "/equipe/perfil", label: "Perfil", icon: <FiUser /> },
  ];

  const itensMaisAdmin = [
    { to: "/admin/gerenciamentocardapio", label: "Cardápio", icon: <MdRestaurantMenu /> },
    { to: "/cadastrogarcons", label: "Garçons", icon: <FiUsers /> },
    { to: "/personalizacaoloja", label: "Personalização", icon: <MdPalette /> },
    { to: "/admin/configuracoes", label: "Configurações", icon: <MdSettings /> },
  ];

  return (
    <>
      <footer className={styles.footermenu}>
        {typeView === 'cliente' ? (
          <>
            <div className={styles.menuItem}>
              <Link to="/homecliente">
                <GoHome className={styles.iconeFooter}/>
                <span className={styles.labelFooter}>Início</span>
              </Link>
            </div>
            <div className={styles.menuItem}>
              <Link to="/pedidoscliente">
                <FiShoppingCart className={styles.iconeFooter}/>
                <span className={styles.labelFooter}>Pedidos</span>
              </Link>
            </div>
            <div className={styles.menuItem}>
              <Link to="/perfilcliente">
                <FiUser className={styles.iconeFooter}/>
                <span className={styles.labelFooter}>Conta</span>
              </Link>
            </div>
          </>
        ) : typeView === 'admin' ? (
          <>
            {/* Admin: 4 fixos + "Mais" com o restante */}
            <div className={styles.menuItem}>
              <Link to="/gestao">
                <GoHome className={styles.iconeFooter}/>
                <span className={styles.labelFooter}>Início</span>
              </Link>
            </div>
            <div className={styles.menuItem}>
              <Link to="/gestaopedidos">
                <VscLayoutMenubar className={styles.iconeFooter}/>
                <span className={styles.labelFooter}>Pedidos</span>
              </Link>
            </div>
            <div className={styles.menuItem}>
              <Link to="/cadastromesas">
                <MdTableRestaurant className={styles.iconeFooter}/>
                <span className={styles.labelFooter}>Mesas</span>
              </Link>
            </div>
            <div className={styles.menuItem}>
              <Link to="/admin/equipe">
                <FiUsers className={styles.iconeFooter}/>
                <span className={styles.labelFooter}>Equipe</span>
              </Link>
            </div>
            <button
              type="button"
              className={styles.menuItem}
              onClick={() => setMaisAberto(true)}
            >
              <MdMoreHoriz className={styles.iconeFooter}/>
              <span className={styles.labelFooter}>Mais</span>
            </button>
          </>
        ) : typeView === 'entregador' ? (
          <>
            {/* Entregador: só 2 destinos, sem "Mais" */}
            <div className={styles.menuItem}>
              <Link to="/equipe/entregador/pedidos">
                <FiTruck className={styles.iconeFooter}/>
                <span className={styles.labelFooter}>Entregas</span>
              </Link>
            </div>
            <div className={styles.menuItem}>
              <Link to="/equipe/entregador/perfil">
                <FiUser className={styles.iconeFooter}/>
                <span className={styles.labelFooter}>Perfil</span>
              </Link>
            </div>
          </>
        ) : (
          <>
            {/* Equipe: 4 fixos + "Mais" com o restante */}
            <div className={styles.menuItem}>
              <Link to="/equipe/home-equipe">
                <GoHome className={styles.iconeFooter}/>
                <span className={styles.labelFooter}>Início</span>
              </Link>
            </div>
            <div className={styles.menuItem}>
              <Link to="/equipe/novo-pedido">
                <MdAddShoppingCart className={styles.iconeFooter}/>
                <span className={styles.labelFooter}>Novo Pedido</span>
              </Link>
            </div>
            <div className={styles.menuItem}>
              <Link to="/equipe/mapa-mesas">
                <MdCropFree className={styles.iconeFooter}/>
                <span className={styles.labelFooter}>Mapa de Mesas</span>
              </Link>
            </div>
            <div className={styles.menuItem}>
              <Link to="/equipe/paineldecontrole">
                <MdOutlineSpaceDashboard className={styles.iconeFooter}/>
                <span className={styles.labelFooter}>Painel Controle</span>
              </Link>
            </div>
            <button
              type="button"
              className={styles.menuItem}
              onClick={() => setMaisAberto(true)}
            >
              <MdMoreHoriz className={styles.iconeFooter}/>
              <span className={styles.labelFooter}>Mais</span>
            </button>
          </>
        )}
      </footer>

      {maisAberto && (
        <div className={styles.sheetOverlay} onClick={() => setMaisAberto(false)}>
          <div className={styles.sheet} onClick={(e) => e.stopPropagation()}>
            <div className={styles.sheetHandle} />
            <div className={styles.sheetGrid}>
              {(typeView === 'admin' ? itensMaisAdmin : itensMais).map(item => (
                <Link
                  key={item.to}
                  to={item.to}
                  className={styles.sheetItem}
                  onClick={() => setMaisAberto(false)}
                >
                  <span className={styles.sheetIcon}>{item.icon}</span>
                  {item.label}
                </Link>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default FooterOpcoes;
